import Close from "@mui/icons-material/Close"
import { Box, DialogContent, IconButton, Typography } from "@mui/material"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogTitle from "@mui/material/DialogTitle"
import { useTranslation } from "react-i18next"

type FormDialogProps = {
  open: boolean
  handleClose: () => void
  title: string
  subtitle?: string | React.ReactNode
  textConfirm: string
  bgConfirm?: "error" | "success" | "primary"
  onConfirm: () => Promise<void>
}

export default function DialogConfirm({
  open,
  handleClose,
  title,
  onConfirm,
  textConfirm,
  bgConfirm = "error",
  subtitle,
}: FormDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={() => {
        handleClose()
      }}
      scroll="paper"
    >
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: "semibold" }} component="h1">
            {title}
          </Typography>
          <IconButton aria-label="close" onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">{subtitle}</Typography>
      </DialogContent>
      <DialogActions
        sx={{
          p: 4,
          flexDirection: "row",
          gap: 4,
        }}
      >
        <Button size="large" onClick={handleClose} variant="text" sx={{ width: "100%" }}>
          {t("general.annulla")}
        </Button>
        <Button color={bgConfirm} size="large" variant="contained" onClick={onConfirm} sx={{ width: "100%" }}>
          {textConfirm}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
